import { type TFunction } from "i18next";

export function getAthleteLimitLabel(
  t: TFunction,
  athleteLimit: number | null,
): string {
  if (athleteLimit === null) {
    return t("pricing.unlimitedAthletes");
  }

  return t("pricing.upToAthletes", { count: athleteLimit });
}

export function getAthleteCountLabel(
  t: TFunction,
  athleteLimit: number | null,
): string {
  if (athleteLimit === null) {
    return t("pricing.unlimitedAthletes");
  }

  return t("pricing.athletesCount", { count: athleteLimit });
}

export function getIntervalLabel(
  t: TFunction,
  interval: "MONTH" | "YEAR",
): string {
  return interval === "YEAR" ? t("pricing.yearly") : t("pricing.monthly");
}

export function getPriceUnitLabel(
  t: TFunction,
  interval: "MONTH" | "YEAR",
): string {
  return interval === "YEAR"
    ? t("pricing.grossPerYear")
    : t("pricing.grossPerMonth");
}
